import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import config from '../../config.json'
import SubmenuItem from '../general/SubmenuItem'

const PageWebsitePage = ({pageName, saveState, status, usedRoutes}) => {
    const routes = config.routes
    
    return (
        <WrapperPageSimple pageTitleTransId={config.routes.website.transId} pageTitle={pageName}>
            <div className="print-page print-type site-content">
                {usedRoutes[0] ? usedRoutes.map((routeKey) => {
                    const { name, transId, path } = routes[routeKey]

                    return <SubmenuItem 
                        key={routeKey} 
                        id={routeKey} 
                        transId={transId}
                        name={name} 
                        path={path}
                    />
                    }
                    ) : (
                        <div>Bitte kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com">Support</a></div>
                    )
                }
            </div>
        </WrapperPageSimple>
    )
}

export default PageWebsitePage  